export const withKasada = (callback: (...args: any[]) => any) => {
  const kasadaSDK = (window as any)?.KPSDK;
  const runningLocally = (window as any)?.oetal?.env?.name === "local";
  if (runningLocally || kasadaSDK?.isReady()) {
    callback();
  } else {
    // wait until Kasada SDK is loaded and ready
    document.addEventListener("kpsdk-ready", () => {
      callback();
    });
  }
};
